import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";
import { matrixConfigSchema, type MatrixConfig } from "./matrixCommon.js";

/**
 * Rows × columns, one answer per row (docs/01-PRODUCT-SPEC.md §3.2). Stored as
 * `{ [rowKey]: columnValue }` — a shape that survives adding a row later, which a positional
 * array would not.
 */
export const matrixRadioField: FieldDescriptor<MatrixConfig> = {
  type: "matrix_radio",
  label: "Matrix (single answer per row)",
  category: "matrix",
  icon: "Grid3x3",
  configSchema: matrixConfigSchema,
  valueSchema: (config, isRequired) => {
    const columnValues = config.columns.map((column) => column.value);
    const cell =
      columnValues.length > 0
        ? z
            .string()
            .refine((value) => columnValues.includes(value), "Not a valid option for this row")
        : z.string();

    const shape: Record<string, z.ZodTypeAny> = {};
    for (const row of config.rows) {
      shape[row.key] = isRequired || config.requireAllRows ? cell : cell.optional();
    }

    return optionalUnlessRequired(z.object(shape).strict(), isRequired);
  },
  defaultConfig: { rows: [], columns: [], requireAllRows: false },
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isComposite: true },
};
